declare const window: any;
import sourceIndexedfiles from './index';
import { h,Fragment } from "./tslib/h";

if (typeof window.tsNameFunctionDictionary === "undefined") {
    window.tsNameFunctionDictionary = new Map<string, Function>();
}
const tsNameFunctionDictionary: Map<string, any> = window.tsNameFunctionDictionary;




(globalThis as any).h = h;
(globalThis as any).Fragment = Fragment;

 console.log("Processing sourceIndexedfiles to tsNameFunctionDictionary");
for (const suspect in sourceIndexedfiles) {
    var prop: any = sourceIndexedfiles[suspect];
    if (prop["thisclass"] && typeof prop.thisclass === "object") {
        //console.log(`Processing thisclass of ${suspect}`);
        addToDictionary(prop.thisclass, suspect);
    }
}

function addToDictionary(obj: any, name: string) {
    for (const key in obj) {
        if (typeof obj[key] === "function") {           
            tsNameFunctionDictionary.set(`${name}|${key}`, { f: obj[key], target: obj });
        }
    }
}


  
